angular.module('bmsApp.settings')
	.controller('DisclaimerTextFormCtrl', function (
		$scope,
		notify,
		$timeout,
		DisclaimerTextSvc
	) {
		var form = {
			validatorConfig: {
				submitHandler: function () {
					$timeout(function () {
						form.processing = true;
						self.errors = null;
						DisclaimerTextSvc.save({disclaimer_text: self.disclaimer_text}).then(function(response) {
							notify({
								message: 'Disclaimer text saved'
							});
						}, function(error) {
							self.errors = error;
						})
						.finally(function () {
							form.processing = false;
						});
					});
				}
			},
			validatorApi: {},
			settingsData: {},
			processing: false
		};

		var self = {
			methods: {
				init: function () {
					DisclaimerTextSvc.read()
						.then(function (response) {
							self.loading = false;
							self.disclaimer_text = response.data.disclaimer_text;
						}, function (errors) {
							self.errors = errors;
						})
						.finally(function () {
							self.loading = false;
						});
				}
			},
			form: form,
			loading: true,
			errors: null
		};

		$scope.DisclaimerTextFormCtrl = self;

	});
